import Vue from 'vue'
import Vuex from 'vuex'
import {
  dataURItoBlob
} from './../_helpers/dataURItoBlob';
import pedidoArchivosService from './../_services/pedidoarchivos.service'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    urlBase: getUrlBase(),
    token: localStorage.userToken || '',
    user: null,
    pedidos: [],
    pedido: null,
    firma: {}
  },
  getters: {
    isAuthenticated: state => !!state.token,
    getToken: state => state.token,
    getTokenUser: state => !!state.token ? atob(state.token.split('.')[1]): null
  },
  mutations: {
    setUser(state, payload) {
      state.token = payload.token;
      localStorage.setItem('userToken', payload.token);
    },
    setFirma(state, payload) {
      state.firma = payload;
    }
  },
  actions: {
    storeFirma(context) {
      let firma = context.state.firma;
      let imgdata = dataURItoBlob(firma.dataURI);

      let formData = new FormData;
      formData.append('archivo', imgdata, 'firma.jpg');
      formData.append('descripcion', 'Firma');

      pedidoArchivosService.sendArchivo(firma.empresa_id, firma.pedido_id, formData)
        .then(result => {
          console.log('Result del service: ', result);
          context.commit('setFirma', {});
        })
    }
  },
  modules: {
  }
})


function getUrlBase() {
  if (window.location.host == 'localhost:8080') {
    // urlApi = 'http://api-test.test';
    return 'http://localhost:8088';
    // urlApi = 'https://online.sepet.es';
    // urlApi = 'https://devonline.sepet.es';
  } else {
    //   'https://devonline.sepet.es';
    return 'https://online.sepet.es';
  }
}